import { useParams } from "react-router-dom";
import Toast from "../../../../common/components/ui/toast";
import { ToastProvider } from "../../../../common/components/ui/toast/toast.provider";
import { RenterDashboardProvider } from "../renter-dashboard/RenterDashboard.provider";
import Dashboard from "../../../../common/components/layout/Dashboard";
import { RenterDashboardRescission } from "./indexRescission";

function RenterDetailsRescissionPage() {
  const { renterId } = useParams()

  return (
    <ToastProvider>
      <Dashboard>
        <RenterDashboardProvider renterId={renterId || ''}>
          <RenterDashboardRescission />
        </RenterDashboardProvider>
      </Dashboard>
      <Toast />
    </ToastProvider>
  )
}

export default RenterDetailsRescissionPage